The scheme ID of the job categories.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
